import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const [open, setOpen] = React.useState(false); 

  var grandTotal=0;

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.topicName} / Questions Availability</h3></div>
                  <p>
                    {(props.topicQuestionCountList && props.topicQuestionCountList.length>0)?<>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <th style={{whiteSpace: 'nowrap',padding:7, width:'40%'}} >Bloom</th>
                            <th style={{whiteSpace: 'nowrap',padding:7}} >Count</th>

                        </tr>
                        {props.topicQuestionCountList.map((row,i)=>( 
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                              <td>{row.bloomName}</td>
                              <td style={{textAlign:'right'}} >
                                {row.counter}
                                <span style={{display:'none'}}>{grandTotal+=row.counter}</span>
                              </td>
                          </tr>
                        ))}
                      </table>
                      {grandTotal>0?<div style={{textAlign:'right'}} >Grand Total: {grandTotal}</div>:null}  
                    </>  
                    :<>No row found</>}

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
      
    </>
  );

});

export default CustomizedDialogs;